export default Object.freeze({
	INCOMPATIBLE: 1,
	ACCOUNT: 2,
	SIZE: 3,
	ESIGN: 4,
	BLANK: 5,
	INVALID: 6
});